import * as React from 'react';
export const IcDoorSensor = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M15.23 2.42a2 2 0 00-1.72-.36l-8 2A2 2 0 004 6v12a2 2 0 001.51 1.94l8 2a2 2 0 002.288-1.06c.133-.275.202-.575.202-.88V4a2.001 2.001 0 00-.77-1.58zM13 13a1 1 0 110-2 1 1 0 010 2zm6-9a1 1 0 00-1 1v14a1 1 0 002 0V5a1 1 0 00-1-1z'
      fill='currentColor'
    />
  </svg>
);
